// import config from "./config"

// 混淆电话号
const confusionPhone = (tel) => {
  tel = '' + tel
  let reg = /(\d{3})\d{4}(\d{4})/
  let res = tel.replace(reg, '$1****$2')
  return res
}

/**获取时长
 * @param {string 时间戳} timesmap
 * @return {string} *天*小时
 */
const getSC = (timesmap) => {
  let time = timesmap / 3600000
  let day = (time / 24).toString().split('.')[0] - 0
  let hour = time % 24
  let str = day ? day + '天' + hour + '时' : hour + '小时'
  return str
}
/**获取星期
 * @param {string 时间戳} date
 * @return {string} 星期
 */
const getWeek = (date) => {
  let week
  date = new Date(date)
  if (date.getDay() == 0) week = '星期日'
  if (date.getDay() == 1) week = '星期一'
  if (date.getDay() == 2) week = '星期二'
  if (date.getDay() == 3) week = '星期三'
  if (date.getDay() == 4) week = '星期四'
  if (date.getDay() == 5) week = '星期五'
  if (date.getDay() == 6) week = '星期六'
  return week
}

const base64src = (base64data) => {
  const fsm = wx.getFileSystemManager()
  const FILE_BASE_NAME = 'tmp_base64src' //自定义文件名
  return new Promise((resolve, reject) => {
    const [, format, bodyData] =
      /data:image\/(\w+);base64,(.*)/.exec(base64data) || []
    if (!format) {
      reject(new Error('ERROR_BASE64SRC_PARSE'))
    }
    const filePath = `${wx.env.USER_DATA_PATH}/${FILE_BASE_NAME}.${format}`
    const buffer = wx.base64ToArrayBuffer(bodyData)
    fsm.writeFile({
      filePath,
      data: buffer,
      encoding: 'binary',
      success() {
        resolve(filePath)
      },
      fail() {
        reject(new Error('ERROR_BASE64SRC_WRITE'))
      },
    })
  })
}

/**
 * 生成随机字符串
 * @param {Number}
 */
const randomString = (e = 32) => {
  let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678',
    a = t.length,
    n = ''
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
  return n
}

/**
 * 加法精度修正
 */
const accAdd = (arg1, arg2) => {
  var r1, r2, m
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}
/**
 * array=>object
 * @param {array} data
 */
const array2Object = (data, key = 'id', value = 'name') => {
  if (data && data.length) {
    let obj = {}
    data.map((item) => {
      obj[item[key]] = item[value]
    })
    return obj
  } else {
    console.error('type error')
  }
}
// 判断元素是否在数组中
const arrContains = (arr, obj) => {
  var i = arr.length
  while (i--) {
    if (arr[i] == obj) {
      return true
    }
  }
  return false
}

// 身份证脱敏
const certifyFormat = (certificateNumber) => {
  // 正则替换
  // return certificateNumber ? certificateNumber.replace(/(?<=\d{3})\d{12}(?=\d{2})/, "****") : '/'
  return certificateNumber
    ? certificateNumber.replace(/^(.{3})(?:\d+)(.{4})$/, '$1****$2')
    : '/'
}

// 身份证验证
const validateIdCard = (personnumber) => {
  personnumber = personnumber.toUpperCase()
  //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
  if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(personnumber)) {
    return false
  }
  //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
  //下面分别分析出生日期和校验位
  var len, re
  len = personnumber.length
  if (len == 15) {
    re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/)
    var arrSplit = personnumber.match(re)

    //检查生日日期是否正确
    var dtmBirth = new Date(
      '19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]
    )
    var bGoodDay
    bGoodDay =
      dtmBirth.getFullYear() == Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
      dtmBirth.getDate() == Number(arrSplit[4])
    if (!bGoodDay) {
      return false
    } else {
      //将15位身份证转成18位
      //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
      var arrInt = new Array(
        7,
        9,
        10,
        5,
        8,
        4,
        2,
        1,
        6,
        3,
        7,
        9,
        10,
        5,
        8,
        4,
        2
      )
      var arrCh = new Array(
        '1',
        '0',
        'X',
        '9',
        '8',
        '7',
        '6',
        '5',
        '4',
        '3',
        '2'
      )
      var nTemp = 0,
        i
      personnumber =
        personnumber.substr(0, 6) +
        '19' +
        personnumber.substr(6, personnumber.length - 6)
      for (i = 0; i < 17; i++) {
        nTemp += personnumber.substr(i, 1) * arrInt[i]
      }
      personnumber += arrCh[nTemp % 11]
      return true
    }
  }
  if (len == 18) {
    re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/)
    var arrSplit = personnumber.match(re)

    //检查生日日期是否正确
    var dtmBirth = new Date(arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4])
    var bGoodDay
    bGoodDay =
      dtmBirth.getFullYear() == Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
      dtmBirth.getDate() == Number(arrSplit[4])
    if (!bGoodDay) {
      return false
    } else {
      //检验18位身份证的校验码是否正确。
      //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
      var valnum
      var arrInt = new Array(
        7,
        9,
        10,
        5,
        8,
        4,
        2,
        1,
        6,
        3,
        7,
        9,
        10,
        5,
        8,
        4,
        2
      )
      var arrCh = new Array(
        '1',
        '0',
        'X',
        '9',
        '8',
        '7',
        '6',
        '5',
        '4',
        '3',
        '2'
      )
      var nTemp = 0,
        i
      for (i = 0; i < 17; i++) {
        nTemp += personnumber.substr(i, 1) * arrInt[i]
      }
      valnum = arrCh[nTemp % 11]
      if (valnum != personnumber.substr(17, 1)) {
        return false
      }
      return true
    }
  }
  return false
}

// 商户号脱敏
const mchidFormat = (number) => {
  return '****'
}
//根据数组中对象的某个属性值进行去重
const uniqueArr = (arr1, from = 'id') => {
  const res = new Map()
  return arr1.filter((a) => !res.has(a[from]) && res.set(a[from], 1))
}
// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time
        .replace(new RegExp(/-/gm), '/')
        .replace('T', ' ')
        .replace(new RegExp(/\.[\d]{3}/gm), '')
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return coerceStringZero(value) || 0
  })
  return time_str
}

// 经纬度转换成三角函数中度分表形式。
function rad(d) {
  return (d * Math.PI) / 180.0
}

export function isToday(str) {
  var d = new Date(str.replace(/-/g, '/'))
  var todaysDate = new Date()
  if (d.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
    return true
  } else {
    return false
  }
}
function keyFormat(arr) {
  if (!arr || !arr.length) {
    return arr
  }
  let list = arr.map((v) => {
    let keys = Object.keys(v)
    keys.forEach((k) => {
      if (k.includes('_')) {
        let newKeyArr = k.split('_')
        let newKeyArr1 =
          newKeyArr[1].slice(0, 1).toUpperCase() +
          newKeyArr[1].slice(1, newKeyArr[1].length)
        let newKey = newKeyArr[0] + newKeyArr1
        v[newKey] = v[k]
      }
    })
    return v
  })
  return list
}

export const debounce = (func, wait, immediate) => {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export const throttle = (fn, wait = 50) => {
  // 上一次执行 fn 的时间
  let previous = 0
  // 将 throttle 处理结果当作函数返回
  return function (...args) {
    // 获取当前时间，转换成时间戳，单位毫秒
    let now = +new Date()
    // 将当前时间和上一次执行函数的时间进行对比
    // 大于等待时间就把 previous 设置为当前时间并执行函数 fn
    if (now - previous > wait) {
      previous = now
      fn.apply(this, args)
    }
  }
}
export function toWei(val,decimal){
  return val* Math.pow(10,decimal) + ''
}
export function fromWei(val,decimal){
  return val/ Math.pow(10,decimal) + ''
}
export function shortenAddress(address) {
  if (!address) return "";
  return `${address.slice(0, 5)}...${address.slice(-5)}`;
}

/** 接口返回的 "0"、"0.0"、"0.00" 等零值数字字符串，统一转为数字 0 */
export function coerceStringZero(value) {
  if (value === 0) return 0;
  if (typeof value === "string") {
    const s = value.trim();
    if (/^0(\.0+)?$/.test(s)) return 0;
  }
  return value;
}

/**
 * 金额展示：零值（含 "0.00"）为 "0"，非零保留 fractionDigits 位小数（四舍五入）。
 * @param {string|number} value
 * @param {number} [fractionDigits=3]
 */
export function formatAmountDisplay(value, fractionDigits = 3) {
  const normalized = coerceStringZero(value);
  const n = Number(normalized);
  if (!Number.isFinite(n) || n === 0) return "0";
  return n.toFixed(fractionDigits);
}

/**
 * 链上最小单位整数换算展示：零为 "0"，非零保留 fractionDigits 位小数。
 */
export function formatScaledAmountDisplay(
  sign,
  digits,
  scale,
  fractionDigits = 3
) {
  if (digits === 0n) return "0";
  return formatIntegerScaledAmountFixed(sign, digits, scale, fractionDigits);
}

/** 首页邀请链接：query 放在 hash 前，便于钱包内置浏览器解析与复制完整 URL */
export function buildHomeInviteUrl(walletAddress) {
  const addr = String(walletAddress || "").trim();
  if (!addr) return "";
  const path = String(location.pathname || "/").replace(/\/$/, "") || "";
  const base = `${location.origin}${path}`;
  return `${base}/?address=${encodeURIComponent(addr)}#/home`;
}

/** 质押页推广链接：当前页面链接 + ?parent=钱包地址 */
export function buildPledgeInviteUrl(walletAddress) {
  const addr = String(walletAddress || "").trim();
  if (!addr) return "";
  const path = String(location.pathname || "/").replace(/\/$/, "") || "";
  const hash = location.hash || "#/pledge";
  return `${location.origin}${path}/?parent=${encodeURIComponent(addr)}${hash}`;
}

/** RAD单币质押页推广链接 */
export function buildRadStakeInviteUrl(walletAddress) {
  const addr = String(walletAddress || "").trim();
  if (!addr) return "";
  const path = String(location.pathname || "/").replace(/\/$/, "") || "";
  const hash = location.hash || "#/rad-stake";
  return `${location.origin}${path}/?parent=${encodeURIComponent(addr)}${hash}`;
}

/**
 * 复制文本到剪贴板。钱包内置 WebView 优先 execCommand，再尝试 Clipboard API。
 * @returns {Promise<boolean>}
 */
export async function copyText(text) {
  const value = String(text ?? "");
  if (!value) return false;

  try {
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.left = "0";
    textarea.style.top = "0";
    textarea.style.width = "2em";
    textarea.style.height = "2em";
    textarea.style.padding = "0";
    textarea.style.border = "none";
    textarea.style.outline = "none";
    textarea.style.boxShadow = "none";
    textarea.style.background = "transparent";
    textarea.style.opacity = "0";
    textarea.style.zIndex = "-1";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, value.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    if (ok) return true;
  } catch (err) {
    console.warn("[copyText] execCommand failed:", err);
  }

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch (err) {
    console.warn("[copyText] clipboard API failed:", err);
  }

  return false;
}

/**
 * @param {string} text
 * @param {{ notify?: boolean }} [options]
 * @returns {Promise<boolean>}
 */
export async function copyAddress(text, options = {}) {
  const { notify = true } = options;
  const ok = await copyText(text);
  if (notify) {
    if (ok) {
      message.success(i18n.t("common.copySuccess"));
    } else {
      message.error(i18n.t("common.copyFailed"));
    }
  }
  if (!ok) {
    console.error("copyAddress failed:", text);
  }
  return ok;
}

/**
 * 链上最小单位整数按固定 decimals 转为十进制字符串（去掉小数尾随 0）。
 * 用于 ERC20 等代币展示；勿与 formatDecimalWithThreeDecimals 的「小于 1 时三位有效数字」混用。
 */
export function formatIntegerScaledAmount(sign, digits, scale) {
  if (digits === 0n) {
    return "0";
  }

  const digitsStr = digits.toString();

  if (scale === 0) {
    return sign < 0 ? `-${digitsStr}` : digitsStr;
  }

  let integerPart;
  let fractionPart;
  if (digitsStr.length <= scale) {
    const zeros = "0".repeat(scale - digitsStr.length);
    integerPart = "0";
    fractionPart = zeros + digitsStr;
  } else {
    const splitIndex = digitsStr.length - scale;
    integerPart = digitsStr.slice(0, splitIndex);
    fractionPart = digitsStr.slice(splitIndex);
  }

  const normalizedInt = integerPart.replace(/^0+/, "") || "0";
  fractionPart = fractionPart.replace(/0+$/, "") || "";

  let result;
  if (!fractionPart) {
    result = normalizedInt;
  } else {
    result =
      normalizedInt === "0"
        ? `0.${fractionPart}`
        : `${normalizedInt}.${fractionPart}`;
  }

  return sign < 0 ? `-${result}` : result;
}

/**
 * 链上最小单位整数换算后保留固定小数位数（四舍五入，右侧不足补 0）。
 * @param {number} fractionDigits 小数位数，非负整数
 */
export function formatIntegerScaledAmountFixed(sign, digits, scale, fractionDigits) {
  const fd = Number(fractionDigits);
  if (!Number.isInteger(fd) || fd < 0 || fd > 36) {
    throw new RangeError("fractionDigits must be an integer from 0 to 36");
  }

  const factor = 10n ** BigInt(fd);
  const zeroFrac = fd === 0 ? "" : `.${"0".repeat(fd)}`;

  if (digits === 0n) {
    const core = `0${zeroFrac}`;
    return sign < 0 ? `-${core}` : core;
  }

  if (scale === 0) {
    const base = digits.toString();
    if (fd === 0) {
      return sign < 0 ? `-${base}` : base;
    }
    return sign < 0 ? `-${base}.${"0".repeat(fd)}` : `${base}.${"0".repeat(fd)}`;
  }

  const absDigits = digits < 0n ? -digits : digits;
  const divisor = 10n ** BigInt(scale);
  const numerator = absDigits * factor;
  const half = divisor / 2n;
  const rounded = (numerator + half) / divisor;

  const intPart = rounded / factor;
  const fracPart = rounded % factor;

  let unsigned;
  if (fd === 0) {
    unsigned = intPart.toString();
  } else {
    unsigned = `${intPart}.${fracPart.toString().padStart(fd, "0")}`;
  }

  const neg = sign < 0;
  return neg ? `-${unsigned}` : unsigned;
}

export function formatDecimalWithThreeDecimals(sign, digits, scale) {
  if (digits === 0n) {
    return "0";
  }

  const digitsStr = digits.toString();

  if (scale === 0) {
    return sign < 0 ? `-${digitsStr}` : digitsStr;
  }

  let integerPart;
  let fractionPart;
  if (digitsStr.length <= scale) {
    const zeros = "0".repeat(scale - digitsStr.length);
    integerPart = "0";
    fractionPart = zeros + digitsStr;
  } else {
    const splitIndex = digitsStr.length - scale;
    integerPart = digitsStr.slice(0, splitIndex);
    fractionPart = digitsStr.slice(splitIndex);
  }

  const normalizedInt = integerPart.replace(/^0+/, "") || "0";
  const isLessThanOne = normalizedInt === "0";

  if (isLessThanOne) {
    // 对于小于 1 的数字，保留三位有效数字
    const allDigitsStr = integerPart + fractionPart;
    const firstNonZeroIndex = allDigitsStr.search(/[1-9]/);

    if (firstNonZeroIndex === -1) {
      return "0";
    }

    // 从第一个非零数字开始，取前三位有效数字
    const significantDigits = allDigitsStr.slice(firstNonZeroIndex);
    if (significantDigits.length === 0) {
      return "0";
    }

    const firstThreeDigits = significantDigits.slice(0, 3);
    const fourthDigit =
      significantDigits.length > 3
        ? parseInt(significantDigits[3] || "0", 10)
        : 0;

    // 四舍五入
    let roundedDigits;
    let needAdjustPosition = false;
    if (fourthDigit >= 5) {
      const rounded = parseInt(firstThreeDigits, 10) + 1;
      if (rounded >= 1000) {
        roundedDigits = "100";
        needAdjustPosition = true;
      } else {
        roundedDigits = rounded.toString().padStart(3, "0");
      }
    } else {
      roundedDigits = firstThreeDigits.padStart(3, "0");
    }

    // 构建结果：0. + 第一个非零数字前的 0 + 三位有效数字
    let result = "0.";
    let zerosCount;

    if (needAdjustPosition) {
      const newFirstNonZeroIndex =
        firstNonZeroIndex > 0 ? firstNonZeroIndex - 1 : 0;
      zerosCount = newFirstNonZeroIndex;
    } else {
      zerosCount = firstNonZeroIndex;
    }

    if (zerosCount > 0) {
      result += "0".repeat(zerosCount);
    }
    result += roundedDigits;

    // 去掉末尾的 0
    result = result.replace(/0+$/, "");
    if (result.endsWith(".")) {
      result = result.slice(0, -1);
    }
    return sign < 0 ? `-${result}` : result;
  } else {
    // 对于大于等于 1 的数字，保留三位小数
    if (fractionPart.length > 3) {
      const fourthDigit = parseInt(fractionPart[3] || "0", 10);
      const firstThreeDigits = fractionPart.slice(0, 3);

      if (fourthDigit >= 5) {
        const rounded = parseInt(firstThreeDigits, 10) + 1;
        if (rounded >= 1000) {
          const intValue = BigInt(normalizedInt) + 1n;
          integerPart = intValue.toString();
          fractionPart = "000";
        } else {
          fractionPart = rounded.toString().padStart(3, "0");
        }
      } else {
        fractionPart = firstThreeDigits;
      }
    } else if (fractionPart.length < 3) {
      fractionPart = fractionPart.padEnd(3, "0");
    }

    fractionPart = fractionPart.replace(/0+$/, "");
    const result = fractionPart
      ? `${normalizedInt}.${fractionPart}`
      : normalizedInt;

    return sign < 0 ? `-${result}` : result;
  }
}

/** @deprecated 请使用 formatDecimalWithThreeDecimals */
export const formatDecimalWithTwoDecimals = formatDecimalWithThreeDecimals;

export default {
  confusionPhone,
  getSC,
  getWeek,
  base64src,
  randomString,
  accAdd,
  array2Object,
  certifyFormat,
  parseTime,
  uniqueArr,
  isToday,
  mchidFormat,
  keyFormat,
  debounce,
  throttle,
  validateIdCard,
  shortenAddress,
  coerceStringZero,
  formatAmountDisplay,
  formatScaledAmountDisplay,
  buildHomeInviteUrl,
  buildPledgeInviteUrl,
  buildRadStakeInviteUrl,
  copyText,
  copyAddress,
  formatIntegerScaledAmount,
  formatIntegerScaledAmountFixed,
  formatDecimalWithThreeDecimals,
  formatDecimalWithTwoDecimals,
}
